/**
 * Modelo de regras de negócio.
 * Define as categorias e regras configuráveis pelo tenant.
 */

export const BUSINESS_RULES_CATEGORIES = [
    {
        id: "Contratos",
        icon: "mdi-file-document-outline",
        description: "Regras de ciclo de vida dos contratos e planos"
    },
    { 
        id: "CRM", 
        icon: "mdi-card-account-phone-outline", 
        description: "Regras de relacionamento e criação de tarefas automáticas" 
    },
    {
        id: "Finanças",
        icon: "mdi-cash-multiple",
        description: "Regras de faturamento e controle de caixa"
    }
];

export const BUSINESS_RULES_DEFINITIONS = [
    {
        id: "membershipGraceDays",
        category: "Contratos",
        label: "Carência após Vencimento",
        description: "Quantidade de dias após o vencimento do contrato para considerar o aluno como inativo. Durante esse período, o aluno permanece ativo e pode renovar sem ser considerado um retorno.",
        icon: "mdi-calendar-clock",
        inputType: "number",
        defaultValue: 7,
        min: 0,
        max: 90,
        suffix: "dias",
        helpText: "Recomendado: 7 dias. Após esse período, o sistema automaticamente inativa o aluno, remove suas matrículas das turmas e sessões futuras, e registra como churn no dashboard.",
        impacts: [
            { icon: "mdi-account-off-outline", text: "Status do aluno muda para Inativo" },
            { icon: "mdi-close-circle-outline", text: "Matrículas (enrollments) são canceladas" },
            { icon: "mdi-calendar-remove", text: "Aluno removido das sessões futuras" },
            { icon: "mdi-chart-line-variant", text: "Métricas de churn são atualizadas" },
        ]
    },
    {
        id: "autoRenewNotificationDays",
        category: "CRM",
        label: "Aviso de Renovação (Contratos)",
        description: "Dias antes do vencimento do plano para criar uma tarefa para o consultor entrar em contato buscando a renovação.",
        icon: "mdi-bell-outline",
        inputType: "number",
        defaultValue: 3,
        min: 1,
        max: 30,
        suffix: "dias antes",
        helpText: "Exemplo: 3. Com 3 dias de antecedência do fim do plano, uma tarefa será criada na Dashboard Operacional.",
        impacts: [
            { icon: "mdi-check-all", text: "Cria tarefa de tipo Renovaçao na Dashboard Operacional" }
        ]
    },
    {
        id: "absenceContactCount",
        category: "CRM",
        label: "Aviso de Evasão (Faltas Consecutivas)",
        description: "Quantidade de faltas consecutivas em aulas agendadas que aciona o alarme de evasão, gerando uma tarefa de resgate.",
        icon: "mdi-account-alert-outline",
        inputType: "number",
        defaultValue: 3,
        min: 1,
        max: 20,
        suffix: "faltas",
        helpText: "Exemplo: 3. Após o aluno acumular 3 faltas consecutivas em suas turmas, uma tarefa será enviada ao consultor. Membros suspensos são ignorados.",
        impacts: [
            { icon: "mdi-check-all", text: "Cria tarefa de tipo Evasão na Dashboard Operacional" }
        ]
    },

    {
        id: "absenceRiskThreshold",
        category: "CRM",
        label: "Risco de Abandono (Faltas)",
        description: "Quantidade de faltas consecutivas para considerar risco elevado de abandono. Afeta a exibição visual na aba Frequência e dashboards.",
        icon: "mdi-account-alert",
        inputType: "number",
        defaultValue: 3,
        min: 1,
        max: 20,
        suffix: "faltas",
        helpText: "Exemplo: 3. Com 3 faltas consecutivas registradas, a aba Frequência destacará o indicador de falhas e pode engatilhar outras flags de risco.",
        impacts: [
            { icon: "mdi-alert-circle-outline", text: "Altera a cor do status de frequência para perigo na aba Perfil" }
        ]
    },
    {
        id: "trialNoShowFollowUpDays",
        category: "CRM",
        label: "Follow-up de Falta na Experimental",
        description: "Quantos dias após a pessoa não comparecer a uma aula experimental para criar uma tarefa de reagendamento.",
        icon: "mdi-calendar-question",
        inputType: "number",
        defaultValue: 1,
        min: 1,
        max: 10,
        suffix: "dias",
        helpText: "Exemplo: 1. No dia seguinte da falta na Experimental, uma tarefa é criada.",
        impacts: [
            { icon: "mdi-check-all", text: "Cria tarefa de Follow-up na Dashboard Operacional" }
        ]
    },
    {
        id: "autoCloseCashier",
        category: "Finanças",
        label: "Fechamento Automático do Caixa",
        description: "Se ativado, o sistema fechará automaticamente às 00:00 qualquer caixa que os consultores tenham deixado aberto no dia.",
        icon: "mdi-timer-off-outline",
        inputType: "boolean",
        defaultValue: false,
        helpText: "Evita que caixas abertos se acumulem e misturem as entradas financeiras do dia anterior.",
        impacts: [
            { icon: "mdi-cash-register", text: "Turnos pendentes serão marcados como fechados pelo sistema ('Fechamento Automático') na virada de meia-noite." }
        ]
    }
];
